import prevBindFn from '../../../../handlers/openInNewTab.js';

export default (props, vars) =>
  typeof prevBindFn === 'function' ? prevBindFn(props, vars) : prevBindFn;
